import { HttpError } from '@dock/common';
import { HttpInstance, interceptorError } from '@dock/http-request';

import { dockPartnerAppInterceptorResponseError } from './dockPartnerAppInterceptorResponseError';

export const dockPartnerMainInterceptorError = (instance: HttpInstance) => (error: HttpError) =>
    interceptorError(error).catch((e) => dockPartnerAppInterceptorResponseError(e, instance));
